// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"134":"b8ea6c31","412":"f76ee97c","453":"413e075a","581":"9250da0e","610":"c998d9fe","627":"223650ad","653":"12b9f112","718":"215dc547","738":"ae165552","923":"57ca2ff0"}[chunkId] + ".chunk.js";
};